import { useState,useEffect } from "react";
import {getOsobeDomace,getOsobeById} from "../../util/apiOsoba";
import {getKnjigeShort} from "../../util/apiKnjiga";
import { getDrzaveById } from "../../util/apiDrzava";
import {Box, Badge, Divider, useToast, Text} from "@chakra-ui/react"
export default function OdlazakFilterInfo({size='xs',leftsidewidth='25%',rightsidewidth='75%', _knjige=[],_tipoviodlazaka=[],_datumi=[],_posjednici=[],
_klaonice=[],_drzave=[],_internmigracijeknjige=[],_period={datod:'1900-01-01',datdo:'1900-01-01'}}) {

const [posjednici,setPosjednici]=useState([]);
const [drzave,setDrzave]=useState([]);
const [klaonice,setKlaonice]=useState([]);
const [knjige,setKnjige]=useState([]);
const [intmigrknjige,seIntMigrtKnjige]=useState([]);
const [err,setErr]=useState("");
const toast=useToast();

useEffect(() => {
    const fetchKlaonice=async()=>{
        try {
            const _res=await getOsobeById({osobe:_klaonice});
            if (_res.status===200) {
              setKlaonice(_res.res);
            } else {
              throw new Error(_res.message);
            }
          } catch (error) {
            setErr(error.message);
          }
    }
    const fetchIntMigrKnjige=async()=>{
        try {
            const _res=await getKnjigeShort();
            if (_res.status===200) {
                seIntMigrtKnjige(_res.res);
            } else {
              throw new Error(_res.message);
            }
          } catch (error) {
            setErr(error.message);
          }
    }
    const fetchDrzave=async()=>{
        try {
            const _res=await getDrzaveById({drzave:_drzave});
            if (_res.status===200) {
              setDrzave(_res.res);
            } else {
              throw new Error(_res.message);
            }
          } catch (error) {
            setErr(error.message);
          }
    }
    const fetchPosjednici=async()=>{
        try {
            const _res=await getOsobeDomace({osobe:_posjednici});
            if (_res.status===200) {
              setPosjednici(_res.res);
            } else {
              throw new Error(_res.message);
            }
          } catch (error) {
            setErr(error.message);
          }
      }
      const fetchKnjige=async()=>{
        try {
            const _res=await getKnjigeShort();
            if (_res.status===200) {
              setKnjige(_res.res);
            } else {
              throw new Error(_res.message);
            }
          } catch (error) {
            setErr(error.message);
          }
      }

  if (_posjednici.length!==0) {
    fetchPosjednici();
  }
  if (_knjige.length>0) {
    fetchKnjige();
  }
  if (_klaonice.length>0) {
    fetchKlaonice();
  }
  if (_drzave.length>0) {
    fetchDrzave();
  }
  if (_internmigracijeknjige.length>0) {
    fetchIntMigrKnjige();
  }
}, [_knjige.length,_posjednici.length,_klaonice.length,_drzave.length,_internmigracijeknjige.length])

const showErr=()=>{
    if (err!=="") {
      setErr("");
      return(
      toast({
        title:"Greška kod dohvata podataka.",
        status:"error",
        description:err,
        isClosable:true,
        duration:2000,
        position:"top-right",
    }));
    
    }
  }

const getKnjige=()=>{
    return (
        <>
        {knjige.map((item,index)=>{
            if (_knjige.includes(String(item.id))) {
                return (<Box key={index} mr={'8px'} mb={'2px'}><Badge>{item.naziv}</Badge></Box>)    
            }
            
        })}
        </>
    )
}
const Knjige=()=>{
    if (_knjige.length>0 && err==="" && knjige.length>0) {
        return (
            <>
        <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                
                <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                    Knjige
                </Box>
                
                <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                    {getKnjige()}
                </Box>
            </Box>
            <Divider/>
            </>
        )    
    }
    
}
const getPosjednici=()=>{
    return (
        <>
        {posjednici.map((item,index)=>{
            if (_posjednici.includes(item.id)) {
                return (<Box key={index} mr={'8px'} mb={'2px'}><Badge>{item.naziv}</Badge></Box>)    
            }
            
        })}
        </>
    )
}
const Posjednici=()=>{
    if (_posjednici.length>0 && err==="" && posjednici.length>0) {
        return (
            <>
            <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                        Posjednici
                    </Box>
                    
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        {getPosjednici()}
                    </Box>
                </Box>
                <Divider/>
            </>
        )
    }
    
}
const getIzvoz=()=>{
    return (
        <>
        {drzave.map((item,index)=>{
            
                return (<Box key={index} mr={'8px'} mb={'2px'}><Badge>{item.naziv}</Badge></Box>)    
            
            
        })}
        </>
    )
}
const Izvoz=()=>{
    if (_drzave.length>0 && err==="" && drzave.length>0) {
        return (
            <>
            <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                        Izvoz
                    </Box>
                    
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        {getIzvoz()}
                    </Box>
                </Box>
                <Divider/>
            </>
        )
    }
    
}
const getKlaonice=()=>{
    return (
        <>
        {klaonice.map((item,index)=>{
            if (_klaonice.includes(item.id)) {
                return (<Box key={index} mr={'8px'} mb={'2px'}><Badge>{item.naziv}</Badge></Box>)    
            }
            
        })}
        </>
    )
}

const Klaonice=()=>{
    if (_klaonice.length>0 && err==="" && klaonice.length>0) {
        return (
            <>
            <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                        Klaonice
                    </Box>
                    
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        {getKlaonice()}
                    </Box>
                </Box>
                <Divider/>
            </>
        )
    }
}

const getIntMigrKnjige=()=>{
    return (
        <>
        {intmigrknjige.map((item,index)=>{
            if (_internmigracijeknjige.includes(String(item.id))) {
                return (<Box key={index} mr={'8px'} mb={'2px'}><Badge>{item.naziv}</Badge></Box>)    
            }
            
        })}
        </>
    )
}

const IntMigrKnjige=()=>{
    if (_internmigracijeknjige.length>0 && err==="" && intmigrknjige.length>0) {
        return (
            <>
            <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                        Interna migracija
                    </Box>
                    
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        {getIntMigrKnjige()}
                    </Box>
                </Box>
                <Divider/>
            </>
        )
    }
}
const OdlasciTipovi=()=>{
  if (_tipoviodlazaka.length!==0) {
      return (
          <>
          <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
              
              <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'bold'}>
                  Odlasci
              </Box>
              <Box w={rightsidewidth} fontSize={size} fm={'2px'} p={'2px'} >
                  <Box display={'flex'} flexDir={'row'}>
                      <Box w={'33%'} fontSize={size}>
                          Prodaja
                      </Box>
                      <Box w={'33%'} fontSize={size}>
                          Izvoz
                      </Box>
                      <Box w={'34%'} fontSize={size}>
                          Int. migracija
                      </Box>
                  </Box>
                  <Box display={'flex'} flexDir={'row'}>
                      <Box w={'33%'}>
                          <Badge>{_tipoviodlazaka.includes('OPROD')?"DA":"NE"}</Badge>
                      </Box>
                      <Box w={'33%'}>
                      <Badge>{_tipoviodlazaka.includes('OIZV')?"DA":"NE"}</Badge>
                      </Box>
                      <Box w={'34%'}>
                      <Badge>{_tipoviodlazaka.includes('OMIK')?"DA":"NE"}</Badge>
                      </Box>
                  </Box>
                  <Box display={'flex'} flexDir={'row'}>
                      <Box w={'33%'} fontSize={size}>
                          Krađa/izgub.
                      </Box>
                      <Box w={'33%'} fontSize={size}>
                          Klaonica
                      </Box>
                      <Box w={'34%'} fontSize={size}>
                          Uginulo
                      </Box>
                  </Box>
                  <Box display={'flex'} flexDir={'row'}>
                      <Box w={'33%'}>
                      <Badge>{_tipoviodlazaka.includes('OIZGB')?"DA":"NE"}</Badge>
                      </Box>
                      <Box w={'33%'}>
                      <Badge>{_tipoviodlazaka.includes('OKLA')?"DA":"NE"}</Badge>
                      </Box>
                      <Box w={'34%'}>
                          <Badge>{_tipoviodlazaka.includes('OUGIN')?"DA":"NE"}</Badge>
                      </Box>
                  </Box>
                  
              </Box>
          </Box>
          <Divider/>
          </>
      )
  }
  
}

const Period=()=>{
    if (_period.datdo!=='1900-01-01' && _period.datod!=='1900-01-01') {
        return (
            <>
            <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                        Period
                    </Box>
                    
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        <Badge>
                            {new Date(_period.datod).toLocaleDateString('hr-HR')} - {new Date(_period.datdo).toLocaleDateString('hr-HR')}
                        </Badge>
                    </Box>
                </Box>
                <Divider/>
            </>
        )
    }
}

const retDisplay=()=>{
    if (_knjige.length===0 && _tipoviodlazaka.length===0 && _datumi.length===0 && _posjednici.length===0 && 
        _klaonice.length===0 && _drzave.length===0 && _internmigracijeknjige.length===0 && (_period.datod==='1900-01-01' && _period.datdo==='1900-01-01')) {
       return ( <>
            <Text fontSize={'lg'} fontWeight={'normal'}>Nema aktivnih filtera</Text>
        </>)
    } else {
        return (
            <>
                 {Knjige()}
                 {OdlasciTipovi()}
                 {Posjednici()}
                 {Klaonice()}
                 {Izvoz()}
                 {IntMigrKnjige()}
                 {Period()}
                {showErr()}
            </>
        )
    }
}
  return (
    <Box>
        {retDisplay()}
    </Box>
  )
}
